import { render, staticRenderFns } from "./slideVerify.vue?vue&type=template&id=4bef35b4&"
import script from "./slideVerify.vue?vue&type=script&lang=js&"
export * from "./slideVerify.vue?vue&type=script&lang=js&"
import style0 from "./slideVerify.vue?vue&type=style&index=0&id=4bef35b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports